<script>
	//Dispatchers
	import { createEventDispatcher } from 'svelte';
	//Design system components
	import { IconButton, Container, Icon, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let list = [];
	export let loadingBtns = {};

	const dispatcher = createEventDispatcher();

	const handle_delete = (email) => {
		dispatcher('delete', email);
	};
</script>

<div class="d-flex flex-direction-column" style="gap: var(--spacing-s)">
	{#each list as email, i (`${email}_${i}`)}
		<Container type="borderSolid" padding="xs">
			<div class="d-flex align-items-center">
				<Icon size="s" class="mr-s" icon="fa-solid fa-envelope" />
				<Text noWrap class="mr-s width-full" styleType="controls-small">
					{email}
				</Text>
				<IconButton
					aria-label={$format('button_remove_user', {
						default: 'Remove user',
					})}
					icon="fas fa-trash"
					variant={$showNewLayout ? 'danger-secondary' : 'danger'}
					loading={loadingBtns[email]}
					disabled={loadingBtns[email]}
					on:click={() => handle_delete(email)}
				/>
			</div>
		</Container>
	{/each}
</div>
